import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling

function NationalGeospatialModel() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div className="pdf-page">
    <iframe
      src={t('NationalGeospatialModel_pdf')}
      title="PDF Document"
    />
  </div>
  );
}

export default NationalGeospatialModel;
